// removed by extract-text-webpack-plugin
module.exports = {"Page":"_2XbtvLO9XcH-rJiQpzhWBw"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Settings/index.css
// module id = 967
// module chunks = 0